// @flow

import React, { type Node } from 'react';
import { Portal } from '@tectonics/commons/portal';
import { type Country } from '@tectonics/prs/country';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Header, TextBlock } from '../../atoms';

export function StatusMessage(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  return (
    <Portal id="bromelia-status-message">
      <div data-test-id="page-confirmed-payment">
        <Header size={2}><HeaderText country={country} /></Header>
        <TextBlock flavor="normal"><BlockText country={country} /></TextBlock>
      </div>
    </Portal>
  );
}

function HeaderText(props: { country: Country }): Node {
  switch (props.country) {
    case 'br':
      return 'Pedido confirmado';
    case 'ar':
    case 'cl':
    case 'co':
    case 'mx':
    case 'uy':
    case 'py':
      return 'Pedido Confirmado';
    default:
      throw new Error(`Text not found for country "${props.country}"`);
  }
}

function BlockText(props: { country: Country }): Node {
  switch (props.country) {
    case 'br':
      return 'Você receberá um e-mail de confirmação com o seu número de pedido em breve.';
    case 'ar':
    case 'cl':
    case 'co':
    case 'mx':
    case 'uy':
    case 'py':
      return 'Recibirá, en breve, un e-mail de confirmación con su número de pedido.';
    default:
      throw new Error(`Text not found for country "${props.country}"`);
  }
}
